export default __webpack_public_path__ + "static/media/Asset 36.b6636d51.png";